import Button from '../../../../components/designSystem/Button/Button';
import photoAccueil from '../../../../assets/images/photo_logo_accueil_cropped.png';

export default () => {
  return (
    <div className="home__firstLayer">
      <div className="home__firstLayerBox">
        <span className="margin-b-sToM font-bold font-size-large text-primary">
          Acheteurs publics,
          <br />
          Mettez fin à la galère des trois devis !
        </span>
        <span className="margin-b-sToM font-bold font-size-large text-secondary">
          Entreprises,
          <br />
          Recevez automatiquement du lead et gagnez en visibilité !
        </span>
        <span className="margin-b-sToM font-bold font-size-small">
          Publiconsult est une plateforme nationale en ligne de consultations hors
          marchés
        </span>
        <a href="#IntroLayer">
          <Button style={{ marginTop: 4 }}>Découvrir Publiconsult</Button>
        </a>
      </div>
      <img className="home__firstLayerBoxImage" src={photoAccueil} />
    </div>
  );
};
